import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import VideoPlayer from 'vue-video-player';
import VueCropper from 'vue-cropper'
import dragTreeTable from 'drag-tree-table'
import axios  from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import _https from '@/https.js'

import VueQuillEditor  from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './assets/icon/iconfont.css'
import global_ from './components/Global'
import {hasBtnPermission} from './api/permission'

// require('./mock.js')
Vue.config.productionTip = false
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(VueQuillEditor);
Vue.use(VideoPlayer);
Vue.use(VueCropper);
Vue.use(dragTreeTable);
Vue.prototype.$axios = axios
Vue.prototype.https = _https;
Vue.prototype.GLOBAL = global_;
Vue.prototype.hasPerm = hasBtnPermission;

function leStatic(actiontype, pagetype='',backup = {}){
    console.log(actiontype);
}
Vue.prototype.$log = leStatic;

const store = new Vuex.Store({
    state: {
        isLogin:'',
        orgCode: '',
        orgType:'',        
        user:'',
        token:'',
        eblcuOrg:'',
    },
    mutations: {
        setIsLogin (state,isLogin) {
            state.isLogin=isLogin;
            localStorage.setItem('isLogin', isLogin);
        },   
        setOrgCode (state,orgCode) {
            state.orgCode=orgCode;
            localStorage.setItem('orgCode', orgCode);
        },
        seOrgType (state,orgType) {
            state.orgType=orgType;
            localStorage.setItem('orgType', orgType);
        },        
        setUser(state,user){
            state.user=user;
            localStorage.setItem('user', JSON.stringify(user));
        },
        setToken(state,token){
            state.token= token;
            localStorage.setItem('token', token);
        },
        setEblcuOrg (state,eblcuOrg) {
            state.eblcuOrg=eblcuOrg;
            localStorage.setItem('eblcuOrg', eblcuOrg);
        },
    }
});


var vue= new Vue({
    router,
    axios,
    Vuex,
    store,
    created(){
        if(localStorage.getItem("isLogin")){
            this.$store.state.isLogin=localStorage.getItem("isLogin");
            this.$store.state.orgCode=localStorage.getItem("orgCode");
            this.$store.state.orgType=localStorage.getItem("orgType");
            this.$store.state.user=JSON.parse(localStorage.getItem("user"));
            this.$store.state.token=localStorage.getItem("token");
            this.$store.state.eblcuOrg=localStorage.getItem("eblcuOrg");
        }
       
    },
    render: h => h(App)
}).$mount('#app')

